export default {"src":"/_next/static/media/right-arrow-grey-icon.2d32e5a4.svg","height":16,"width":16};